// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "e53d40f22dffa4b0b836" + ".chunk.js";
};